<div class="evento-form-error">
  <i class="fas fa-info-circle"></i>
  {{ message }}
</div>
